const detailsPage = { type: 'details' };
const landingPage = { type: 'landing' };
const summaryPage = { type: 'summary' };
const detailsRegex = /^\/guide\/(.+)\/details$/;
const summaryRegex = /^\/guide\/(.+)\/summary$/;
const surveyRegex = /^\/guide\/spa\/(.+)\/(.+)\/(.+)$/;

const extractPageFromPath = (pathname) => {
  if (pathname === '/guide') {
    return landingPage;
  }

  if (summaryRegex.test(pathname)) {
    return summaryPage;
  }

  if (detailsRegex.test(pathname)) {
    return detailsPage;
  }

  const surveyTest = surveyRegex.exec(pathname);

  if (surveyTest && surveyTest.length === 4) {
    const pathKey = surveyTest[2];
    const pageKey = surveyTest[3];

    return {
      type: 'survey',
      path: {
        key: pathKey
      },
      page: {
        key: pageKey
      }
    };
  }

  return landingPage;
};

const PAGE_TYPES = {
  landingPage: 'landing',
  surveyPage: 'survey',
  summaryPage: 'summary',
  detailsPage: 'details'
};

export {
  extractPageFromPath as default,
  PAGE_TYPES
};
